const locale = {
	DASHBOARDS: 'Dashboard',
	DASHBOARD_USER: 'Dashboard Utente',
	DASHBOARD_KPIS: 'Dashboard KPI',
	DASHBOARD_POWERBI_STATS: 'Statistiche PowerBI',

	REGISTRIES: 'Anagrafiche',
	COMPANIES: 'Aziende',
	CUSTOMERS: 'Clienti',
	SUPPLIERS: 'Fornitori',
	OTHERS: 'Altro',
	PEOPLE: 'Persone',
	ITEMS: 'Prodotti',
	CONTACTS: 'Contatti',
	MAILS: 'Indirizzi mail',
	PHONENUMBERS: 'Numeri di telefono',
	SOCIALNETWORKS: 'Social network',

	MARKETING: 'Marketing',
	MARKETINGACTIONS: 'Azioni Marketing',
	DEMS: 'DEM',

	SALES: 'Commerciale',
	COMMERCIALCAMPAIGNS: 'Campagne Commerciali',
	OPPORTUNITIES: 'Opportunità',
	NAV_QUOTATIONS: 'Offerte NAV',
	NAV_ORDERS: 'Ordini NAV',
	CONTRACTS: 'Contratti',
	ORDERS: import.meta.env.VITE_ENDPOINT === 'https://crm.borcianiebonazzi.com' ? "Proposte d'Ordine" : 'Offerte',

	MANAGEMENT: 'Gestione incarichi',
	PROJECTS: 'Progetti',
	ACTIVITIES: 'Attività',
	WORKREPORTS: 'Rapportini',
	CHRONOLOGY: 'Cronologia',
	TICKETS: 'Ticket',
	PHONECALLS: 'Telefonate',

	SYSTEM: 'Sistema',
	TAGS: 'Etichette',
	USERS: 'Utenti',
	GROUPS: 'Gruppi',
	RECYCLE_BIN: 'Cestino',
	LOGS: 'Log di sistema',
	EXCHANGE_MAILS_LOGS: 'Log mail Exchange',
	SYSTEM_TABLES: 'Tabelle di sistema',
	PERMISSIONS_MANAGEMENT: 'Gestione permessi',
	SETTINGS: 'Impostazioni'
};

export default locale;
